module.exports = __webpack_public_path__ + "img/picture_activity.223a277f.jpg";